import { Component, OnDestroy, OnInit } from "@angular/core";
import { PatrimonioLiquidoService, NovoPatrimonioLiquidoDTO } from "../../patrimonio-liquido.service";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MensagemService } from "src/app/features/mensagem.service";
import moment from "moment";
import { DatePipe } from "@angular/common";
import Utils from "src/app/shared/fgi-utils";
import { PermissaoService } from "src/app/shared/permissao.service";
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO, ROLE_AGENTE_CONSULTA } from "src/app/constantes/permissao.constants";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalidadeService } from "src/app/shared/services/modalidade.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { MODALIDADE_GARANTIA_FGBS, MODALIDADE_GARANTIA_PEAC_BS_EX } from "src/app/model/modalidade_garantia.model";

@Component({
    selector: 'app-novo-patrimonio-liquido',
    templateUrl: './novo-patrimonio-liquido.component.html',
    styleUrls: ['./novo-patrimonio-liquido.component.scss'],
    standalone: false
})
export class NovoPatrimonioLiquidoComponent implements OnInit, OnDestroy {

  dataHora: string;
  patrimonioForm:UntypedFormGroup;
  nomeUsuarioResponsavel: string = '';
  ultimaDataBase: Date;
  formOk: boolean = false;
  podeCadastrarPatrimonio: boolean = false;
  idPatrimonioLiquido: number;
  estaEditando: boolean;
  iniciouEdicao: boolean;
  placeHolderDataBase = 'MM/AAAA';
  bnMaskDataBase = 'MESANO';
  modalidadePermiteMaisDeUmaDataBaseNoMes = false;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private patrimonioLiquidoService: PatrimonioLiquidoService,
    private mensagemService: MensagemService,
    private formBuilder:UntypedFormBuilder,
    private datePipe: DatePipe,
    private permissaoService: PermissaoService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private modalidadeService: ModalidadeService,
    ) {
      this.patrimonioForm = this.formBuilder.group({
        dataBase: '',
        valor: null,
      });

      this.patrimonioForm.valueChanges.subscribe(() => { this.validaForm() });
    }

  ngOnInit(): void {
    this.estaEditando = false;
    this.iniciouEdicao = false;
    this.activatedRoute.params
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
      this.idPatrimonioLiquido = params['id'];
      this.retornaInfoPatrimonioLiquido();

      if (this.idPatrimonioLiquido) {
        this.estaEditando = true;
        this.patrimonioForm.get('dataBase').disable();
      }
    });

    this.permissaoService.getPermissoesUsuarioAutenticado()
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp: any) => {
          this.podeCadastrarPatrimonio = resp && resp[ROLE_GESTOR_ENVIO];
    });

    this.modalidadeService.modalidade$
      .pipe(takeUntil(this.destroy$))
      .subscribe(modalidade => {
        this.modalidadePermiteMaisDeUmaDataBaseNoMes = (modalidade === MODALIDADE_GARANTIA_FGBS || modalidade === MODALIDADE_GARANTIA_PEAC_BS_EX)
        if (this.modalidadePermiteMaisDeUmaDataBaseNoMes) {
          this.placeHolderDataBase = 'DD/MM/AAAA';
          this.bnMaskDataBase = 'DATA';
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async retornaInfoPatrimonioLiquido() {
    await this.patrimonioLiquidoService.getInfoPatrimonioLiquido(this.idPatrimonioLiquido)
    .toPromise().then(response => {
      this.nomeUsuarioResponsavel = response?.nome || '';
      this.ultimaDataBase = response?.ultimaDataBase || null;
      this.dataHora = moment(response.dataRegistro).format('DD/MM/YYYY HH:mm:ss');
      this.patrimonioForm.setValue({
        valor: response?.valor || null,
        dataBase: this.temDataBase(this.ultimaDataBase),
      });

      this.patrimonioForm.get('valor').valueChanges.subscribe(() => { this.iniciouEdicao = true; });
    });
  }

  temDataBase(ultimaDataBase: Date) {
    if (ultimaDataBase) {
      return moment(ultimaDataBase).format('MM/YYYY');
    } else if (this.modalidadePermiteMaisDeUmaDataBaseNoMes) {
      return moment().format('MM/YYYY');
    } else {
      return moment().subtract(1, 'month').format('MM/YYYY');
    }
  }

  validaForm() {
    return this.formOk = !this.patrimonioForm.invalid && this.podeCadastrarPatrimonio
    && (!this.estaEditando || this.iniciouEdicao);
  }

  async salvar() {
    if (this.patrimonioForm.invalid) {
      this.patrimonioForm.markAllAsTouched();
      return;
    }

    const form = this.patrimonioForm.getRawValue();
    let dataFormatada = this.datePipe.transform(form.dataBase,"yyyy-MM-dd");
    if (!this.modalidadePermiteMaisDeUmaDataBaseNoMes) {
      dataFormatada = this.datePipe.transform(form.dataBase,"yyyy-MM-01")
    }
    const novoPatrimonioLiquido: NovoPatrimonioLiquidoDTO = {
      id: this.idPatrimonioLiquido,
      dataBase: dataFormatada,
      valor: form.valor
    }

    try {
      await this.patrimonioLiquidoService.salvar(novoPatrimonioLiquido).toPromise();
      this.mensagemService.adicionarMensagemSucesso('Patrimônio Líquido criado/atualizado com sucesso.');
      this.irParaPesquisa();
      this.limpar();
    } catch (err) {
      console.log('Erro ao salvar patrimônio líquido', err);
      this.mensagemService.adicionarMensagemErro('Erro ao salvar patrimônio líquido');
    }
  }

  limpar(){
    this.patrimonioForm.markAsUntouched();
    this.patrimonioForm.setValue({
      valor: null,
      dataBase: this.temDataBase(this.ultimaDataBase),
    });
    this.irParaPesquisa();
  }

  irParaPesquisa() {
    this.router.navigate(['habilitacao', 'patrimonio-liquido']);
  }
}
